import { createContext, useContext } from 'react'
import { type ImmediatelyStore } from 'shared/ui/Schedule/ui/Immediately'

export const ImmediatelyContext = createContext<ImmediatelyStore | null>(null)

export function useImmediatelyContext() {
  const context = useContext(ImmediatelyContext)
  if (context === null) {
    throw new Error('You have forgotten to wrap your root component with ImmediatelyContext')
  }
  return context
}
